import { RouteObject } from 'react-router-dom';
import AdminLayout from '@/pages/admin/layout/AdminLayout';
import TeacherLayout from '@/pages/teacher/layout/TeacherLayout';
import LoginPage from '@/pages/login/page';
import AdminDashboardPage from '@/pages/admin/dashboard/page';
import BasvurularPage from '@/pages/admin/basvurular/page';
import OgrencilerPage from '@/pages/admin/ogrenciler/page';
import OgrenciDetayPage from '@/pages/admin/ogrenciler/detay/page';
import OgretmenlerPage from '@/pages/admin/ogretmenler/page';
import OgretmenDetayPage from '@/pages/admin/ogretmenler/detay/page';
import YonlendirmePage from '@/pages/admin/yonlendirme/page';
import DenemeDersleriPage from '@/pages/admin/deneme-dersleri/page';
import AktifDerslerPage from '@/pages/admin/aktif-dersler/page';
import OdemelerPage from '@/pages/admin/odemeler/page';
import HakEdislerPage from '@/pages/admin/hak-edisler/page';
import GrupDersleriPage from '@/pages/admin/grup-dersleri/page';
import RaporlarPage from '@/pages/admin/raporlar/page';
import AyarlarPage from '@/pages/admin/ayarlar/page';
import TeacherDashboardPage from '@/pages/teacher/dashboard/page';
import OgrencilerimPage from '@/pages/teacher/ogrencilerim/page';
import DenemeDerslerimPage from '@/pages/teacher/deneme-derslerim/page';
import AktifDerslerimPage from '@/pages/teacher/aktif-derslerim/page';
import DersNotlariPage from '@/pages/teacher/ders-notlari/page';
import DekontGirisleriPage from '@/pages/teacher/dekont-girisleri/page';
import KazanclarimPage from '@/pages/teacher/kazanclarim/page';
import ProfilimPage from '@/pages/teacher/profilim/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <LoginPage /> },

  // Admin Panel
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: 'dashboard', element: <AdminDashboardPage /> },
      { path: 'basvurular', element: <BasvurularPage /> },
      { path: 'ogrenciler', element: <OgrencilerPage /> },
      { path: 'ogrenciler/:id', element: <OgrenciDetayPage /> },
      { path: 'ogretmenler', element: <OgretmenlerPage /> },
      { path: 'ogretmenler/:id', element: <OgretmenDetayPage /> },
      { path: 'yonlendirme', element: <YonlendirmePage /> },
      { path: 'deneme-dersleri', element: <DenemeDersleriPage /> },
      { path: 'aktif-dersler', element: <AktifDerslerPage /> },
      { path: 'odemeler', element: <OdemelerPage /> },
      { path: 'hak-edisler', element: <HakEdislerPage /> },
      { path: 'grup-dersleri', element: <GrupDersleriPage /> },
      { path: 'raporlar', element: <RaporlarPage /> },
      { path: 'ayarlar', element: <AyarlarPage /> },
    ],
  },

  // Teacher Panel
  {
    path: '/teacher',
    element: <TeacherLayout />,
    children: [
      { index: true, element: <TeacherDashboardPage /> },
      { path: 'dashboard', element: <TeacherDashboardPage /> },
      { path: 'ogrencilerim', element: <OgrencilerimPage /> },
      { path: 'deneme-derslerim', element: <DenemeDerslerimPage /> },
      { path: 'aktif-derslerim', element: <AktifDerslerimPage /> },
      { path: 'ders-notlari', element: <DersNotlariPage /> },
      { path: 'dekont-girisleri', element: <DekontGirisleriPage /> },
      { path: 'kazanclarim', element: <KazanclarimPage /> },
      { path: 'profilim', element: <ProfilimPage /> },
    ],
  },

  { path: '*', element: <NotFound /> },
];

export default routes;